import React, { useEffect, createRef, RefObject } from "react";
import {
  Image,
  TouchableOpacity,
  StyleSheet,
  TextInput,
  View,
  Platform,
} from "react-native";
import searchIcon from "./assets/icons/icon_search.png";
import clearIcon from "./assets/icons/icon_clear_small.png";
import colours from "./styles/colours";
import { Typography } from "./styles/typography";
import { Spacing, BorderRadius } from "./styles/number";
import * as PlatformUtils from "../modules/platformUtils";

const styles = (isFocused: boolean) =>
  StyleSheet.create({
    container: {
      flex: 1,
      borderWidth: 2,
      borderColor: isFocused ? colours.black : colours.lightGrey,
      borderRadius: BorderRadius.Medium,
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
      padding: Spacing.ExtraLight,
    },
    textInput: {
      flex: 1,
      marginLeft: Spacing.Narrow,
      ...Typography.bodyBold,
      lineHeight: 16,
      padding: 0,
    },
    placeHolderText: {
      flex: 1,
      marginLeft: Spacing.Narrow,
      ...Typography.body,
      lineHeight: 16,
      padding: 0,
    },
    searchIcon: {
      width: 24,
      height: 24,
      resizeMode: "cover",
      tintColor: isFocused ? colours.black : colours.uiGrey,
    },
    clearIcon: {
      width: 24,
      height: 24,
      resizeMode: "cover",
      tintColor: colours.uiGrey,
    },
  });

export interface SearchTextInputProps {
  value: string;
  onChangeText: (text: string) => void;
  isFocused: boolean;
  setFocused: (focus: boolean) => void;
  onClear: () => void;
  onSearch: () => void;
  placeHolder?: string;
}
export default function SearchTextInput(props: SearchTextInputProps) {
  const {
    setFocused,
    isFocused,
    onChangeText,
    value,
    onClear,
    onSearch,
    placeHolder,
  } = props;
  const inputRef: RefObject<TextInput> = createRef();
  useEffect(() => {
    if (!isFocused) {
      inputRef?.current?.blur();
    }
  }, [isFocused, inputRef]);

  return (
    <View style={styles(isFocused).container}>
      <TouchableOpacity
        {...PlatformUtils.generateTestID(Platform.OS, `SearchStoreSearchBtn`)}
        onPress={onSearch}>
        <Image style={styles(isFocused).searchIcon} source={searchIcon} />
      </TouchableOpacity>
      <TextInput
        {...PlatformUtils.generateTestID(Platform.OS, `SearchStoreInput`)}
        ref={inputRef}
        value={value}
        onChangeText={onChangeText}
        style={
          value === ""
            ? styles(isFocused).placeHolderText
            : styles(isFocused).textInput
        }
        placeholderTextColor={colours.midGrey}
        onFocus={() => setFocused(true)}
        placeholder={placeHolder}
      />
      {isFocused && (
        <TouchableOpacity
          {...PlatformUtils.generateTestID(Platform.OS, `SearchStoreClearBtn`)}
          onPress={onClear}>
          <Image style={styles(isFocused).clearIcon} source={clearIcon} />
        </TouchableOpacity>
      )}
    </View>
  );
}
